import { routes, copyFor } from 'config';

const getCopy = copyFor('settings.utilitySync');
type QueriedUtilityCredential =
  GetUtilitySyncDataQuery['account']['utilityCredentials'][number];
type QueriedUtility = QueriedUtilityCredential['utility'];

export const API_TOKEN_TYPE = 'APIToken';
export const USERNAME_PASSWORD_TYPE = 'UsernamePassword';
export const CONED_DISPLAY_NAME = 'ConEd';
export const CONED_ACCOUNT_NUMBER_LENGTH = 15;
export const UTILITY_IDS_AMEREN = [2311, 2441];

export const getAmerenRedirectUri = (): string => {
  const { utilitySyncEdit } = routes();
  const host = window.location.hostname;
  const port = window.location.port;
  let baseUrl = `${window.location.protocol}//${host}`;
  if (port) baseUrl += `:${port}`;
  return `${baseUrl}${utilitySyncEdit}`;
};

export const API_TOKEN_UTILITY_PORTAL_MAP = {
  ...UTILITY_IDS_AMEREN.reduce((acc, id) => {
    acc[id] = `${
      process.env.ARCADIA_AMEREN_URL
    }&redirect_uri=${getAmerenRedirectUri()}`;
    return acc;
  }, {} as Record<number, string>),
};

export const isApiTokenUtility = (utility: QueriedUtility) =>
  utility &&
  Object.keys(API_TOKEN_UTILITY_PORTAL_MAP).includes(utility.id.toString());

export const isApiTokenCredential = (
  utilityCredential: QueriedUtilityCredential
) => utilityCredential.type === API_TOKEN_TYPE;

export const utilityCredentialIncorrect = (status: string) =>
  status === 'incorrect';

interface Params {
  utilityCredential: QueriedUtilityCredential;
}

const isApiTokenUtilityAndCredential = ({ utilityCredential }: Params) =>
  isApiTokenUtility(utilityCredential.utility) &&
  isApiTokenCredential(utilityCredential);

export const getUtilityCredentialSubLabel = (params: Params): string => {
  const { utilityCredential } = params;
  const status = utilityCredential.verificationStatus;
  if (status === 'empty') return getCopy('status.empty');
  if (isApiTokenUtilityAndCredential({ utilityCredential })) {
    if (status === 'correct' || status === 'incorrect')
      return getCopy(`status.${status}`);
    else return getCopy('status.unverified');
  } else return utilityCredential.username || '';
};

export const UTILITY_CREDENTIAL_ID_FOR_SYNC = 'utility_credential_id_for_sync';
